export default __webpack_public_path__ + "static/media/blog-post-layout-01-img-08.b72f4f99.jpg";